import { call, all, select, put } from "redux-saga/effects";

import { sendSchoolMoneyDataRequest } from "state/fetchSagas";
import { getParentsLackingEmailAddresses } from "state/school_money/selectors";
import { fetchParents } from "state/school_money/actions";

export default function* updateParentEmailAddressSaga(action) {

  const { emailAddress } = action.payload;
  const parents = yield select(getParentsLackingEmailAddresses);

  const apiCallEffects = [];
  for (const parent of parents) {

    const { serverID, remoteSchoolID, remoteID } = parent;

    const callEffect = call(sendSchoolMoneyDataRequest, "update_parent_email", {
      server_id: serverID,
      remote_school_id: remoteSchoolID,
      remote_parent_id: remoteID,
      parent_email: emailAddress
    });

    apiCallEffects.push(callEffect);

  }

  yield all(apiCallEffects);

  yield put(fetchParents(true));

}



// WEBPACK FOOTER //
// ./src/state/school_money/sagas/updateParentEmailAddressSaga.js